<script lang="ts">
    import * as Dialog from "$lib/components/ui/dialog/index.js";
    import { Button, buttonVariants } from "$lib/components/ui/button/index.js";
    import { t } from "svelte-i18n";
    import { ScrollArea } from "$lib/components/ui/scroll-area/index.js";
    import { Mail, Printer } from "lucide-svelte";
  import HtmlEditor from "./components/HtmlEditor.svelte";
  import SelectMailTemplate from "./components/select-mail-template.svelte";
  
    let isOpen: boolean = false;
  </script>
  
  <Dialog.Root bind:open={isOpen}>
    <Dialog.Trigger>
      <Button variant="secondary" size="sm">
        <Mail class="h-4 w-4" />
      </Button>
    </Dialog.Trigger>
    <Dialog.Content
      class="flex flex-col h-dvh sm:h-[650px] sm:my-auto overflow-hidden sm:max-h-dvh"
    >
      <Dialog.Header>
        <Dialog.Title>{$t("page.projects.mails.title")}</Dialog.Title>
      </Dialog.Header>
      <SelectMailTemplate />
      <Button>
        {$t('page.projects.mails.apply-template')}
      </Button>
      <div class="flex flex-col flex-grow h-full overflow-hidden">
        
      <HtmlEditor />
        <!-- <ScrollArea orientation="vertical">
          <div class="grid w-full h-full grid-cols-2 gap-2 max-w-md p-2"></div>
        </ScrollArea> -->
      </div>
      <Dialog.Footer class="flex pt-4">
        <Button type="submit" class="px-8">
          {$t("global.messages.ok")}
        </Button>
        <Button  class="px-8">
            {$t("global.messages.cancel")}
          </Button>
      </Dialog.Footer>
    </Dialog.Content>
  </Dialog.Root>
  